/**
  *
  * PageContent.js v1.0.0
  *
  * If your project is not on the Babel workflow, scroll down to the bottom
  * and use the ES5 version instead of the ES6+ version.
  *
  */

;((PageContent, $) => {
  'use strict';

  let $dom = {};

  const cacheDom = () => {
    $dom.body = $('body');
    $dom.header = $('.main-header-wrapper');
    $dom.banner = $('.js-countdown-banner');
    $dom.content = $('.main-content-wrapper');
  };

  const getCountdownBannerHeight = function () {
    return $('.js-countdown-banner').outerHeight();
  };

  const getGlobalHeaderHeight = function () {
    return $('.main-header-wrapper').outerHeight(true);
  };

  const getTransformationHeaderHeight = () => {
    return $('.mobile-transformation-link-header').is(':visible')
      ? $('.mobile-transformation-link-header').height()
      : 0
  }

  const getCombinedHeight = () => {
    return getGlobalHeaderHeight()
  }

  const init = () => {

    $('.main-content-wrapper').css('padding-top', getCombinedHeight() + 'px');

  };

  const bindUIActions = () => {
    $(window).on('resize orientationchange', () => {
      init();
    });
  };

  PageContent.init = () => {
    bindUIActions();
    init();
  };

})(window.PageContent = window.PageContent || {}, jQuery);

